import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import axios from 'axios'
import mixins from './mixins';

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
// Importa tus archivos CSS
import '@/assets/css/app.css'
import '@/assets/css/index.css'
import '@/assets/css/default.css'
import '@/assets/css/header.css'
import '@/assets/css/footer.css'
import '@/assets/css/floats.css'
import '@/assets/css/responsive.css'
import '@/assets/css/style.css'

// Páginas específicas
import '@/assets/css/slider.css'
import '@/assets/css/galeria.css'
import '@/assets/css/services.css'
import '@/assets/css/institutional.css'
import '@/assets/css/process.css'
import '@/assets/css/events.css'
import '@/assets/css/news.css'
import '@/assets/css/contact.css'
import '@/assets/css/birthday.css'
import '@/assets/css/about.css'
import '@/assets/css/courses.css'
import '@/assets/css/mesa.css'

// Plugins de FontAwesome
import '@/assets/plugins/fontawesome/css/all.min.css'

window.$ = window.jQuery = require('jquery');//Esto es cuando se instala desde consola
window.baseUrl = process.env.VUE_APP_ROOT_API
window.tokenAPI = process.env.VUE_APP_TOKEN_API
window.baseCli = process.env.VUE_APP_ROOT_CLI

const instance = axios.create({
	baseURL: window.baseUrl,
	headers: {
		Authorization: 'Bearer ' + window.tokenAPI
	}
})

Vue.config.productionTip = false
Vue.config.silent = true; // Desactiva todos los warnings de Vue

//console.error = () => {};
//console.warn = () => {};


Vue.mixin(mixins);
Vue.prototype.$http = instance;
new Vue({
	store,
	router,
	render: function (h) {
		return h(App)
	}
}).$mount('#app')
